import StartingPageContent from './StartingPageContent';

const HomePage = () => {
  return <StartingPageContent />;
};

export default HomePage;
